import { TextField } from '@mui/material'
import css from './NumberInput.module.css'

const NumberInput = ({ className = '', name, label, value, onChange }) => {
  const handleChange = e => {
    const { value } = e.target
    const newValue = value.replace(',', '.').replace(/[^0-9.]/g, '')
    onChange(newValue)
  }

  return (
    <TextField
      className={`${className} ${css.main}`}
      id={name}
      value={value}
      onChange={handleChange}
      label={label}
      variant='standard'
    />
  )
}

export default NumberInput
